import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    templateUrl: 'confirmDateDialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmDateDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  todaysDate = new Date();
  chosenDate: Date | undefined = undefined;
  header = '';
  message = '';
  warning = '';

  ngOnInit () {
    this.header = this.data.header || 'Choose a date to issue nor letter';
    this.message = this.data.message || 'Click the dropdown';
    this.warning = this.data.warning || 'This action is irreversible, please be careful.';
  }


  save() {
    this.dialogRef.close(this.chosenDate);
  }

  cancel() {
    this.dialogRef.close(false);
  }



}
